import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { can } from "../utils/can";

const BASE_URL = process.env.REACT_APP_BASE_URL || "";

const MENU_CONFIG = [
  {
    key: "dashboard",
    title: "Dashboard",
    icon: "far fa-home",
    path: "/dashboard",
    permission: "dashboard"
  },
  {
    key: "user",
    title: "User Management",
    icon: "far fa-users",
    permission: "user_management",
    prefix: "user",
    children: [
      { title: "All Members", path: "/user/all-member", permission: "all_members" },
      { title: "Paid Members", path: "/user/paid-member", permission: "paid_members" },
      { title: "Deleted Members", path: "/user/deleted-member", permission: "all_members" },
      { title: "Visitors", path: "/user/member-enquiry", permission: "visitors" },
      { title: "Bulk Email", path: "/user/bulk-email", permission: "bulk_email" },
      { title: "Bulk SMS", path: "/user/bulk-sms", permission: "bulk_sms" }
    ]
  },
  {
    key: "profile",
    title: "Profile Management",
    icon: "far fa-user-check",
    permission: "profile_management",
    prefix: "profile",
    children: [
      { title: "Profile Approval", path: "/profile/profile-approval", permission: "profile_approval" },
      { title: "Document Approval", path: "/profile/document-approval", permission: "document_approval" },
      { title: "Photo Approval", path: "/profile/photo-approval", permission: "photo_approval" }
    ]
  },
  {
    key: "attribute",
    title: "Attribute",
    icon: "far fa-th-large",
    permission: "attribute",
    prefix: "attribute",
    children: [
      { title: "Religion", path: "/attribute/religion", permission: "religion" },
      { title: "Caste", path: "/attribute/cast", permission: "caste" },
      { title: "Sub Caste", path: "/attribute/sub-cast", permission: "sub_caste" },
      { title: "Gotra", path: "/attribute/gotra", permission: "gotra" },
      { title: "Language", path: "/attribute/language", permission: "language" },
      { title: "Occupation", path: "/attribute/occupation", permission: "occupation" },
      { title: "Working With", path: "/attribute/working-with", permission: "working_with" },
      { title: "Hobbies", path: "/attribute/hobbies", permission: "hobbies" },
      { title: "Education", path: "/attribute/education", permission: "education" },
      { title: "Professional Education", path: "/attribute/professional-education", permission: "professional_education" },
      { title: "Matchmaking Compatibility", path: "/attribute/mm-compatibuility", permission: "matchmaking_compatibility" },
      { title: "Country", path: "/attribute/country", permission: "country" },
      { title: "State", path: "/attribute/state", permission: "state" },
      { title: "City", path: "/attribute/city", permission: "city" }
    ]
  },
  {
    key: "agent",
    title: "Agent",
    icon: "far fa-users",
    permission: "agent",
    prefix: "agent",
    children: [
      { title: "Add Agent", path: "/agent/add-agent", permission: "add_agent" },
      { title: "View Agent", path: "/agent/view-agent", permission: "view_agent" },
      { title: "View Leads", path: "/agent/view-leads", permission: "view_agent" }
    ]
  },
  {
    key: "membership",
    title: "Membership Plans",
    icon: "far fa-crown",
    permission: "membership_plans",
    prefix: "membership",
    children: [
      { title: "View Plan", path: "/membership/view-plan", permission: "view_plan" },
      { title: "Coupon", path: "/membership/add-coupon", permission: "coupon" },
      { title: "Renew Member List", path: "/membership/renew-member-list", permission: "renew_members_list" }
    ]
  },
  {
    key: "notification",
    title: "Notification",
    icon: "far fa-bell",
    path: "/notification",
    permission: "notification"
  },
  {
    key: "profile-promotion",
    title: "Profile Promotion",
    icon: "far fa-ad",
    path: "/profile-promotion",
    permission: "profile_promotion"
  },
  {
    key: "transaction-history",
    title: "Transaction History",
    icon: "far fa-history",
    path: "/transaction-history",
    permission: "transaction_history"
  },
  {
    key: "testimonials",
    title: "Testimonials",
    icon: "far fa-comment-alt",
    permission: "testimonials",
    prefix: "testimonials",
    children: [
      { title: "Add Testimonials", path: "/testimonials/add-testimonials", permission: "add_testimonials_and_success_stories" },
      { title: "View Testimonials", path: "/testimonials/view-testimonials", permission: "view_testimonials_and_success_stories" }
    ]
  },
  {
    key: "customer-support",
    title: "Customer Support",
    icon: "far fa-life-ring",
    permission: "customer_support",
    prefix: "customer-support",
    children: [
      { title: "Enquiry List", path: "/customer-support/enquiry-list", permission: "enquiry_list" },
      { title: "Reported Chat", path: "/customer-support/reported-chat", permission: "reported_chat" }
    ]
  },
  {
    key: "blog",
    title: "Blog",
    icon: "far fa-newspaper",
    path: "/blog",
    permission: "blog"
  },
  {
    key: "cms",
    title: "CMS",
    icon: "far fa-clipboard-list-check",
    permission: "cms",
    prefix: "cms",
    children: [
      { title: "Slider Image", path: "/cms/homepage", permission: "slider_image" },
      { title: "FAQ/Help", path: "/cms/faq", permission: "faq" },
      { title: "Feedback", path: "/cms/feedback", permission: "feedback" },
      { title: "Privacy Policy", path: "/cms/privacy-policy", permission: "privacy_policy" },
      { title: "Terms & Conditions", path: "/cms/terms-condition", permission: "terms_and_conditions" },
      { title: "Disclaimer", path: "/cms/disclaimer", permission: "disclaimer" },
      { title: "About Us", path: "/cms/about", permission: "about_us" },
      { title: "Export Data", path: "/cms/export-data", permission: "export_data" },
      { title: "Number Stats", path: "/cms/number-stats", permission: "cms_number_stats" },
      { title: "Home Page", path: "/cms/page-home", permission: "cms_home_page" },
      { title: "State Home Page", path: "/cms/page-state", permission: "cms_state_home_page" },
      { title: "Bihar City Page", path: "/cms/page-bihar-city", permission: "cms_bihar_city_page" },
      { title: "Religion Page", path: "/cms/page-religion", permission: "cms_religion_page" },
      { title: "Caste Page", path: "/cms/page-caste", permission: "cms_caste_page" }
    ]
  },
  {
    key: "roles-permissions",
    title: "Roles & Permissions",
    icon: "far fa-ballot-check",
    permission: "role_permission",
    prefix: "roles-permissions",
    children: [
      { title: "Add Sub Admin", path: "/roles-permissions/add-subadmin" },
      { title: "View Sub Admin", path: "/roles-permissions/view-subadmin" },
      { title: "Member Login OTP", path: "/roles-permissions/member-common-login-otp" },
      { title: "Staff Member Login", path: "/roles-permissions/staff-member-login" }
    ]
  }
];

const Sidebar = () => {
  const userType = localStorage.getItem("adminRole");
  const location = useLocation();

  const normalize = (p) => {
    if (!p) return "";
    let clean = p.replace(/^https?:\/\/[^\/]+/, "");
    clean = clean.replace(/^\/admin/, "");
    clean = clean.split("?")[0].split("#")[0];
    if (clean.length > 1 && clean.endsWith("/")) {
      clean = clean.slice(0, -1);
    }
    return clean || "/";
  };

  const [activeOpenKey, setActiveOpenKey] = useState(() => {
    const current = normalize(window.location.pathname);
    const matchedItem = MENU_CONFIG.find(
      (item) => item.prefix && current.startsWith(normalize(item.prefix))
    );
    if (matchedItem) {
      return matchedItem.key;
    }
    return sessionStorage.getItem("adminSidebarOpenKey") || null;
  });

  useEffect(() => {
    const current = normalize(location.pathname);
    const matchedItem = MENU_CONFIG.find(
      (item) => item.prefix && current.startsWith(normalize(item.prefix))
    );
    if (matchedItem) {
      setActiveOpenKey(matchedItem.key);
      sessionStorage.setItem("adminSidebarOpenKey", matchedItem.key);
    }
  }, [location.pathname]);

  // Close flyout popup when clicking outside sidebar
  useEffect(() => {
    const handleClickOutside = (e) => {
      const sidebar = document.getElementById("sidebar-menu");
      if (sidebar && !sidebar.contains(e.target)) {
        setActiveOpenKey(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("touchstart", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
    };
  }, []);

  const isActive = (path) => {
    if (!path) return false;
    const current = normalize(location.pathname);
    const target = normalize(path);
    if (current === target) return true;
    if (target !== "/" && (current.startsWith(`${target}/`) || current.startsWith(`${target}?`))) return true;
    return false;
  };

  const isParentActive = (prefix) => {
    if (!prefix) return false;
    const current = normalize(location.pathname);
    const cleanPrefix = normalize(prefix);
    return current.startsWith(cleanPrefix);
  };

  const isMenuOpen = (menuKey) => {
    return activeOpenKey === menuKey;
  };

  const handleParentClick = (menuKey, e) => {
    if (e) e.preventDefault();
    setActiveOpenKey((prev) => {
      const next = prev === menuKey ? null : menuKey;
      if (next) {
        sessionStorage.setItem("adminSidebarOpenKey", next);
      } else {
        sessionStorage.removeItem("adminSidebarOpenKey");
      }
      return next;
    });
  };

  return (
    <div
      className="col-md-3 left_col"
      style={{
        position: "sticky",
        top: 0,
        height: "100vh",
        overflow: "visible",
        scrollbarWidth: "none",
        msOverflowStyle: "none",
        zIndex: 999,
      }}
    >
      <style>{`
        /* Fixed Desktop Sidebar Layout (Expanded mode >= 992px) */
        @media (min-width: 992px) {
          .nav-md .container.body .col-md-3.left_col,
          .nav-md .left_col {
            position: fixed !important;
            top: 30px !important;
            left: 30px !important;
            width: 260px !important;
            height: calc(100vh - 40px) !important;
            max-height: calc(100vh - 40px) !important;
            overflow-y: auto !important;
            scrollbar-width: none !important;
            -ms-overflow-style: none !important;
            z-index: 999 !important;
            float: none !important;
          }
        }

        .left_col::-webkit-scrollbar {
          display: none !important;
        }

        /* Make ALL Submenus Scrollable with a max-height */
        #sidebar-menu ul.child_menu {
          max-height: 360px !important;
          overflow-y: auto !important;
          scrollbar-width: thin !important;
          scrollbar-color: #ff85b3 #fff0f6 !important;
        }

        #sidebar-menu ul.child_menu::-webkit-scrollbar {
          width: 5px !important;
        }

        #sidebar-menu ul.child_menu::-webkit-scrollbar-track {
          background: #fff0f6 !important;
          border-radius: 4px !important;
        }

        #sidebar-menu ul.child_menu::-webkit-scrollbar-thumb {
          background: #ff85b3 !important;
          border-radius: 4px !important;
        }

        /* Base resets for child menu list items */
        #sidebar-menu ul.child_menu li {
          padding-left: 0 !important;
          background: transparent !important;
        }

        /* Top level parent menu styling when active */
        #sidebar-menu ul.side-menu > li.active > a {
          color: #bf3272 !important;
          font-weight: 600 !important;
          background: linear-gradient(90deg, #ffeaf4 0%, #fff7fa 100%) !important;
          border-radius: 0 50px 50px 0 !important;
        }
        #sidebar-menu ul.side-menu > li.active > a i,
        #sidebar-menu ul.side-menu > li.active > a span {
          color: #bf3272 !important;
        }

        /* Inactive child submenu items link style */
        #sidebar-menu ul.child_menu li > a {
          color: #444444 !important;
          font-size: 13px !important;
          padding: 8px 10px 8px 30px !important;
          font-weight: 500 !important;
          background: transparent !important;
          border-radius: 0 50px 50px 0 !important;
          transition: all 0.2s ease-in-out !important;
        }

        /* Hover style for child submenus */
        #sidebar-menu ul.child_menu li > a:hover {
          color: #bf3272 !important;
          background: #fff0f6 !important;
        }

        /* ACTIVE child submenu item link text & pill background style */
        #sidebar-menu ul.child_menu li > a.active-sub-item,
        .active-sub-item {
          color: #bf3272 !important;
          font-weight: 700 !important;
          background: linear-gradient(90deg, #ffeaf4 0%, #fff7fa 100%) !important;
          border-radius: 0 50px 50px 0 !important;
          padding-left: 32px !important;
          display: block !important;
          border-left: 4px solid #bf3272 !important;
        }

        /* COLLAPSED / NARROW SIDEBAR (.nav-sm) AND MOBILE (< 992px) POPUP FLYOUT MENU */
        body.nav-sm .left_col,
        .nav-sm .left_col {
          overflow: visible !important;
          z-index: 99999 !important;
        }

        body.nav-sm #sidebar-menu ul.side-menu > li,
        .nav-sm #sidebar-menu ul.side-menu > li {
          position: relative !important;
        }

        @media (max-width: 991px) {
          .left_col {
            overflow: visible !important;
            z-index: 99999 !important;
          }
          #sidebar-menu ul.side-menu > li {
            position: relative !important;
          }
        }

        body.nav-sm #sidebar-menu ul.child_menu.show-child-menu,
        .nav-sm #sidebar-menu ul.child_menu.show-child-menu,
        .nav-sm .menu_section ul.side-menu li ul.child_menu.show-child-menu,
        .nav-sm ul.nav.child_menu.show-child-menu {
          display: block !important;
          visibility: visible !important;
          opacity: 1 !important;
          position: absolute !important;
          left: calc(100% + 5px) !important;
          top: 0 !important;
          min-width: 220px !important;
          max-width: 260px !important;
          max-height: 360px !important;
          overflow-y: auto !important;
          background: #ffffff !important;
          border-radius: 14px !important;
          box-shadow: 0 10px 30px rgba(191, 50, 114, 0.25), 0 4px 14px rgba(0,0,0,0.12) !important;
          border: 1.5px solid #ffc2dd !important;
          padding: 8px 6px !important;
          margin-left: 8px !important;
          z-index: 999999 !important;
        }

        @media (max-width: 991px) {
          #sidebar-menu ul.child_menu.show-child-menu {
            display: block !important;
            visibility: visible !important;
            opacity: 1 !important;
            position: absolute !important;
            left: calc(100% + 5px) !important;
            top: 0 !important;
            min-width: 220px !important;
            max-width: 260px !important;
            max-height: 360px !important;
            overflow-y: auto !important;
            background: #ffffff !important;
            border-radius: 14px !important;
            box-shadow: 0 10px 30px rgba(191, 50, 114, 0.25), 0 4px 14px rgba(0,0,0,0.12) !important;
            border: 1.5px solid #ffc2dd !important;
            padding: 8px 6px !important;
            z-index: 999999 !important;
          }

          #sidebar-menu ul.child_menu.show-child-menu li > a {
            color: #333333 !important;
            padding: 9px 14px !important;
            font-size: 13px !important;
            font-weight: 500 !important;
            border-radius: 8px !important;
            margin: 2px 0 !important;
            display: block !important;
            white-space: nowrap !important;
            text-overflow: ellipsis !important;
            overflow: hidden !important;
            transition: all 0.2s ease !important;
          }
          #sidebar-menu ul.child_menu.show-child-menu li > a:hover,
          #sidebar-menu ul.child_menu.show-child-menu li > a.active-sub-item {
            background: #ffeaf4 !important;
            color: #bf3272 !important;
            font-weight: 700 !important;
            padding-left: 18px !important;
          }
        }
      `}</style>
      <div className="left_col scroll-view" style={{ minHeight: "100vh", overflow: "visible" }}>
        <div className="navbar nav_title" style={{ border: 0 }}>
          <Link to={userType === "sub_admin"
            ? `${BASE_URL}/sub-admin-dashboard`
            : `${BASE_URL}/dashboard`
          } className="site_title">
            <img src={`${process.env.PUBLIC_URL || ""}/assets/images/logo.png`} alt="Vivashri logo" />
          </Link>
        </div>

        <div className="clearfix"></div>

        <div id="sidebar-menu" className="main_menu_side hidden-print main_menu" style={{ overflow: "visible" }}>
          <div className="menu_section" style={{ overflow: "visible" }}>
            <ul className="nav side-menu">
              {MENU_CONFIG.map((item) => {
                if (item.permission && !can(item.permission)) {
                  return null;
                }

                if (!item.children) {
                  const linkPath = `${BASE_URL}${item.path}`;
                  const active = isActive(linkPath) || (item.key === "dashboard" && isActive(`${BASE_URL}/sub-admin-dashboard`));
                  return (
                    <li key={item.key} className={active ? "active" : ""}>
                      <Link to={linkPath} className={active ? "active-sub-item" : ""} onClick={() => setActiveOpenKey(null)}>
                        <i className={item.icon}></i> {item.title}
                      </Link>
                    </li>
                  );
                }

                const parentActive = isParentActive(item.prefix);
                const open = isMenuOpen(item.key);

                return (
                  <li key={item.key} className={parentActive ? "active" : ""}>
                    <Link to="#" onClick={(e) => handleParentClick(item.key, e)}>
                      <i className={item.icon}></i> {item.title} <span className={open ? "far fa-angle-up" : "far fa-angle-down"}></span>
                    </Link>
                    <ul className={`nav child_menu ${open ? "show-child-menu" : ""}`} style={{ display: open ? "block" : "none" }}>
                      {item.children.map((child, idx) => {
                        if (child.permission && !can(child.permission)) {
                          return null;
                        }
                        const childPath = `${BASE_URL}${child.path}`;
                        const childActive = isActive(childPath);

                        return (
                          <li key={idx}>
                            <Link to={childPath} className={childActive ? "active-sub-item" : ""} onClick={() => setActiveOpenKey(null)}>
                              {child.title}
                            </Link>
                          </li>
                        );
                      })}
                    </ul>
                  </li>
                );
              })}
              <li>
                <Link to={`${BASE_URL}/logout`}>
                  <i className="far fa-sign-out-alt"></i> Logout
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
